import React from "react"
import { Accordion as AccordionComponent, Box, Container, Heading } from "@chakra-ui/react"
import AccordionItem from "@components/AccordionItem"
import { useContent } from "@hooks/useContent"

const Accordion = ({ title, items, theme }: GatsbyTypes.SanitySectionAccordion) => {
  const { getContent } = useContent()

  return (
    <Box my={3} bg={theme === "Dark" ? "brand.beige.dark" : "white"}>
      <Heading as="h4" size="h3" textAlign="center">
        {title}
      </Heading>
      <Container pt={2} pb={4} w={["unset", "648px"]} minW={"unset"} px={[2, "0 !important"]}>
        <AccordionComponent allowMultiple>
          {items?.map(({ title, content, i }) => (
            <AccordionItem title={title} key={i}>
              {getContent({ content: content })}
            </AccordionItem>
          ))}
        </AccordionComponent>
      </Container>
    </Box>
  )
}
export default Accordion
